import {
  Component,
  EventEmitter,
  Output,
  QueryList,
  ViewChildren,
  inject,
  OnInit,
  Input,
} from '@angular/core';

import { environment } from '../../../../environments/environment';
import { AdditionalInfo, UserSettings } from '@lp-ui-lib';
import { CurrentTelemetry } from '@lp-ui-lib';
import { GraphData } from '@lp-ui-lib';
import { I18nService } from '@lp-ui-lib';
import { UiService } from '@lp-ui-lib';
import { GraphDisplay } from '../../../models/classes/graphDisplay';
import { SensorValueComponent } from '../../../components/sensor-value/sensor-value';
import { TabBarComponent } from '../../../components/tab-bar/tab-bar';
import { TabBarItemComponent } from '../../../components/tab-bar/tab-bar-item/tab-bar-item';
import { SpinnerComponent } from '@lp-ui-lib';
import { DatePipe } from '@angular/common';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { FormsModule } from '@angular/forms';
import { GraphComponent } from '../../../components/graph/graph';
import { NzIconModule } from 'ng-zorro-antd/icon';

export const STEAM_TRAP_STATUS_ID = 1068;
export const STEAM_TRAP_STEAM_LOSS_AMOUNT_ID = 1069;
export const STEAM_TRAP_STEAM_LOSS_MASS_ID = 1070;
const STEAM_TRAP_STEAM_LOSS_CO2_ID = 9999;
export const STEAM_TRAP_STEAM_LOSS_MASS_WEEK_ID = 1083;
export const STEAM_TRAP_STEAM_LOSS_MASS_MONTH_ID = 1085;
export const STEAM_TRAP_STEAM_LOSS_MASS_3MONTH_ID = 1087;
export const STEAM_TRAP_STEAM_LOSS_AMOUNT_WEEK_ID = 1084;
export const STEAM_TRAP_STEAM_LOSS_AMOUNT_MONTH_ID = 1086;
export const STEAM_TRAP_STEAM_LOSS_AMOUNT_3MONTH_ID = 1088;

const CO2_CONVERSION_FACTOR = 0.16;

@Component({
  selector: 'app-steam-trap-analytics',
  imports: [
    SensorValueComponent,
    TabBarComponent,
    TabBarItemComponent,
    SpinnerComponent,
    FormsModule,
    DatePipe,
    NzDatePickerModule,
    NzIconModule,
    GraphComponent,
  ],
  templateUrl: './steam-trap-analytics.html',
  styleUrl: './steam-trap-analytics.scss',
})
export class SteamTrapAnalytics implements OnInit {
  graphDisplays: any[] = [];
  @Input() set NoPricePerTon(noPricePerTon: boolean) {
    if (noPricePerTon) {
      this.displaySteamTrapLossAmount = false;
      this.hideSteamTrapLossAmount = true;
      this.showPricePerTonError = true;
    }
  }
  @Input() set GraphDisplays(graphDisplays: any[]) {
    this.graphDisplays = graphDisplays;

    this.calcSteamLossInfo();
    this.calcSteamLossAmountPrediction();
    this.calcSteamLossMassPrediction();
  }
  graphData: GraphData[] = [];
  @Input() set GraphData(graphData: GraphData[]) {
    // do I need to add the data here?
    this.graphData = graphData;
    this.setSteamLossMassUnitString();
    this.setSteamLossCo2UnitString();
    this.setSteamLossCurrencyUnitGraph();
    this.calcSteamLossInfo();
    this.calcSteamLossAmountPrediction();
    this.calcSteamLossMassPrediction();
  }
  steamLossPrediction: CurrentTelemetry[] = [];
  @Input() set SteamLossPrediction(steamLossPrediction: CurrentTelemetry[]) {
    this.steamLossPrediction = steamLossPrediction;
  }
  telemetry: CurrentTelemetry[] = [];
  @Input() set SteamTrapTelemetry(telemetry: CurrentTelemetry[]) {
    this.telemetry = telemetry;
    this.calcSteamLossInfo();
    this.calcSteamLossAmountPrediction();
    this.calcSteamLossMassPrediction();
  }
  get Telemetry(): any {
    if (!this.telemetry || this.telemetry.length === 0) return null;
    return this.telemetry[0];
  }
  @Input() loading = false;
  @Input() isTelemetryTimeframeCustom = false;
  @Input() set Range(range: Date[]) {
    this.range = [new Date(range[0]), new Date(range[1])];

    this.calcSteamLossInfo();
    this.calcSteamLossAmountPrediction();
    this.calcSteamLossMassPrediction();
  }

  public DISPLAY_STEAM_TRAP_LOSS_AMOUNT = 1;
  public DISPLAY_STEAM_TRAP_LOSS_MASS = 2;
  public DISPLAY_STEAM_TRAP_LOSS_CO2 = 3;

  public displayViz: number = this.DISPLAY_STEAM_TRAP_LOSS_AMOUNT;
  public displaySteamTrapLossAmount = true;
  public hideSteamTrapLossAmount = false;
  public graphBrushActive = false;
  public showPricePerTonError = false;

  public range: Date[] = [new Date(new Date().setDate(new Date().getDate() - 1)), new Date()];
  @Input() settings: UserSettings | any = null;

  @Input() SteamLossCurrencyUnit: AdditionalInfo | any = null;

  @Output() OnTelemetryTimeframeSelect = new EventEmitter<{
    index: number;
    telemetry: CurrentTelemetry;
  }>();
  @Output() OnRangeStartPick = new EventEmitter<{
    measurementTypeID: number;
    sensorID: number;
    event: any;
    endPickerID: number;
    data: any;
  }>();
  @Output() OnRangeEndPick = new EventEmitter<{
    measurementTypeID: number;
    sensorID: number;
    event: any;
    data: any;
  }>();
  @Output() OpenRangePicker = new EventEmitter<{
    id: number;
    data: any;
  }>();
  @Output() OnRangePickerSelect = new EventEmitter<{
    event: any;
    data: any;
  }>();
  @Output() RangePickerDisabledDate = new EventEmitter<{
    data: any;
    id: number;
  }>();
  @Output() dateRangeUpdatedfromGraph = new EventEmitter<string[]>();
  @ViewChildren('datePick') datePickers: QueryList<any> | null = null;

  public steamTrapLossMassSum = '';
  public steamTrapLossAmountSum = '';
  public steamTrapLossCo2Sum = '';

  public steamTrapLossAmount1Week = 0;
  public steamTrapLossAmount1Month = 0;
  public steamTrapLossAmount3Months = 0;

  public steamTrapLossMass1Week = 0;
  public steamTrapLossMass1Month = 0;
  public steamTrapLossMass3Months = 0;

  public steamLossCurrencyUnit = '€';
  public steamLossMassUnit = '';
  public steamLossCo2Unit = '';

  public i18n = inject(I18nService);
  public ui = inject(UiService);

  get OverviewContent(): string {
    return this.displayViz === this.DISPLAY_STEAM_TRAP_LOSS_CO2
      ? this.i18n.langString('co2_content')
      : this.i18n.langString('steam_loss_overview_content');
  }

  get SteamTrapStatusCurrentTelemetry(): CurrentTelemetry | null {
    if (!this.graphDisplays) return null;
    const statusGraphDisplay = this.graphDisplays.find(
      (item) => item.currentTelemetry.measurementTypeID === STEAM_TRAP_STATUS_ID
    );
    if (!statusGraphDisplay) return null;
    return statusGraphDisplay.currentTelemetry;
  }

  get SteamTrapHealth(): any[] {
    if (!this.graphDisplays) return [];
    const steamTrapHealth = this.graphDisplays.find(
      (display) => display.currentTelemetry.measurementTypeID === STEAM_TRAP_STATUS_ID
    );
    return steamTrapHealth ? [steamTrapHealth] : [];
  }
  get SteamTrapLoss(): any[] {
    if (this.displayViz === this.DISPLAY_STEAM_TRAP_LOSS_AMOUNT) {
      return this.SteamTrapLossAmount;
    } else if (this.displayViz === this.DISPLAY_STEAM_TRAP_LOSS_CO2) {
      return this.SteamTrapLossCo2;
    } else {
      //(this.displayViz === this.DISPLAY_STEAM_TRAP_LOSS_MASS)
      return this.SteamTrapLossMass;
    }
  }

  get HasSteamLossCurrencyUnit(): any {
    return (
      this.SteamLossCurrencyUnit &&
      this.SteamLossCurrencyUnit.text &&
      this.SteamLossCurrencyUnit.text !== ''
    );
  }

  get HasSteamTrapLossAmount(): boolean {
    const result = !!this.graphDisplays.find(
      (display) => display.currentTelemetry.measurementTypeID === STEAM_TRAP_STEAM_LOSS_AMOUNT_ID
    );
    if (!result) this.displaySteamTrapLossAmount = false;
    return result && !this.hideSteamTrapLossAmount;
  }

  get HasSteamTrapLossMass(): boolean {
    return !!this.graphDisplays.find(
      (display) => display.currentTelemetry.measurementTypeID === STEAM_TRAP_STEAM_LOSS_MASS_ID
    );
  }

  get HasSteamTrapLossCo2(): boolean {
    return !!this.graphDisplays.find(
      (display) => display.currentTelemetry.measurementTypeID === STEAM_TRAP_STEAM_LOSS_CO2_ID
    );
  }

  get SteamTrapLossAmount(): GraphDisplay[] {
    return this.getGraphDisplay(STEAM_TRAP_STEAM_LOSS_AMOUNT_ID);
  }

  get SteamTrapLossMass(): GraphDisplay[] {
    return this.getGraphDisplay(STEAM_TRAP_STEAM_LOSS_MASS_ID);
  }

  get SteamTrapLossAmountWeek(): CurrentTelemetry | any {
    return this.steamLossPrediction
      ? this.steamLossPrediction.find(
          (item) => item.measurementTypeID === STEAM_TRAP_STEAM_LOSS_AMOUNT_WEEK_ID
        )
      : null;
  }

  get SteamTrapLossMassWeek(): CurrentTelemetry | any {
    return this.steamLossPrediction
      ? this.steamLossPrediction.find(
          (item) => item.measurementTypeID === STEAM_TRAP_STEAM_LOSS_MASS_WEEK_ID
        )
      : null;
  }

  get SteamTrapLossAmountMonth(): CurrentTelemetry | any {
    return this.steamLossPrediction
      ? this.steamLossPrediction.find(
          (item) => item.measurementTypeID === STEAM_TRAP_STEAM_LOSS_AMOUNT_MONTH_ID
        )
      : null;
  }

  get SteamTrapLossMassMonth(): CurrentTelemetry | any {
    return this.steamLossPrediction
      ? this.steamLossPrediction.find(
          (item) => item.measurementTypeID === STEAM_TRAP_STEAM_LOSS_MASS_MONTH_ID
        )
      : null;
  }

  get SteamTrapLossAmount3Month(): CurrentTelemetry | any {
    return this.steamLossPrediction
      ? this.steamLossPrediction.find(
          (item) => item.measurementTypeID === STEAM_TRAP_STEAM_LOSS_AMOUNT_3MONTH_ID
        )
      : null;
  }

  get SteamTrapLossMass3Month(): CurrentTelemetry | any {
    return this.steamLossPrediction
      ? this.steamLossPrediction.find(
          (item) => item.measurementTypeID === STEAM_TRAP_STEAM_LOSS_MASS_3MONTH_ID
        )
      : null;
  }

  // get SteamTrapLossCo2(): GraphDisplay[] | any {
  //   return this.getGraphDisplay(STEAM_TRAP_STEAM_LOSS_CO2_ID);
  // }
  get SteamTrapLossCo2(): GraphDisplay[] | any {
    return this.SteamTrapLossMass.map((display: GraphDisplay) => ({
      ...display,
      graphData: (display.graphData ?? []).map((data: GraphData) => ({
        ...data,
        metadata: {
          ...data.metadata,
          unit: this.steamLossCo2Unit || this.steamLossMassUnit || 'Kg',
        },
        telemetry: (data.telemetry ?? []).map((telemetry: any) => ({
          ...telemetry,
          value: this.convertMassToCo2Value(telemetry.value),
        })),
      })),
    }));
  }

  private convertMassToCo2Value(value: unknown): number {
    const numericValue = typeof value === 'number' ? value : Number(value ?? 0);

    return Number.isFinite(numericValue) ? numericValue * CO2_CONVERSION_FACTOR : 0;
  }

  getGraphDisplay(measurementTypeID: number): GraphDisplay[] {
    if (!this.graphDisplays) return [];
    const graphDisplay = this.graphDisplays.find(
      (display) => display.currentTelemetry.measurementTypeID === measurementTypeID
    );
    return graphDisplay ? [graphDisplay] : [];
  }

  get DateFormat(): string {
    return this.settings?.dateFormats?.formatString;
  }
  get Locale(): string {
    return this.settings?.languages?.abbreviation === 'de' ? 'de-DE' : 'en-US';
  }

  get isMobile(): boolean {
    return this.ui.IsMobile();
  }
  get isTablet(): boolean {
    return this.ui.IsTablet();
  }
  get isDesktop(): boolean {
    return this.ui.IsDesktop();
  }
  private lastTimeframeSelectIndex = 0;

  ngOnInit() {
    if (!environment.disableSelectedSteamRateCurrency && this.SteamLossCurrencyUnit) {
      this.steamLossCurrencyUnit = JSON.parse(this.SteamLossCurrencyUnit?.text).en;
    }
  }

  onTelemetryTimeframeSelect(index: number, telemetry: CurrentTelemetry): void {
    this.lastTimeframeSelectIndex = index;
    this.OnTelemetryTimeframeSelect.emit({
      index: index,
      telemetry: telemetry,
    });
  }

  onDateRangeUpdatedfromGraph(event: any) {
    this.dateRangeUpdatedfromGraph.emit(event);
  }

  onRangeStartPick(measurementTypeID: any, sensorID: any, event: any, endPickerID: any, data: any) {
    this.OnRangeStartPick.emit({
      measurementTypeID: measurementTypeID,
      sensorID: sensorID,
      event: event,
      endPickerID: endPickerID,
      data: data,
    });
  }
  onRangeEndPick(measurementTypeID: any, sensorID: any, event: any, data: any) {
    this.OnRangeEndPick.emit({
      measurementTypeID: measurementTypeID,
      sensorID: sensorID,
      event: event,
      data: data,
    });
  }

  onRangePickerSelect(event: any, data: any) {
    this.OnRangePickerSelect.emit({
      event: event,
      data: data,
    });
  }

  openRangePicker(id: any, data: any) {
    this.OpenRangePicker.emit({
      id: id,
      data: data,
    });
  }
  getVisibleGraphs(telemetry: CurrentTelemetry) {
    if (!telemetry) return [];
    const display: GraphDisplay | any = this.graphDisplays.find(
      (graphDisplay) =>
        graphDisplay?.currentTelemetry?.measurementTypeID === telemetry?.measurementTypeID &&
        graphDisplay?.currentTelemetry?.sensor?.sensorID === telemetry?.sensor?.sensorID
    );
    return !!display && display.graphData
      ? display.graphData.filter((graphData: any) => graphData.metadata.displayGraph)
      : [];
  }
  noData(data: GraphData) {
    return !data || !data.telemetry.length;
  }
  noDataTelemetry(telemetry: CurrentTelemetry) {
    return !this.getVisibleGraphs(telemetry).find((data: GraphData) => !this.noData(data));
  }
  rangePickerDisabledDate(data: any, pickerIndex: any): (current: Date) => boolean {
    if (!data) {
      return () => false;
    }
    let otherDate: any = null; // otherDate removes the ability to create empty timespans (in other words, pick the same day twice)
    if (pickerIndex === 1) otherDate = this.range[1];
    if (pickerIndex === 2) otherDate = this.range[0];
    if (otherDate) otherDate = new Date(otherDate.toDateString()); // remove time from datetime object
    let first: Date = new Date(Date.parse(data.metadata.firstMeasurement));
    first = new Date(first.toDateString()); // remove time from datetime object
    let last: Date = new Date(Date.parse(data.metadata.lastMeasurement));
    last = new Date(last.toDateString()); // remove time from datetime object
    const fn = (current: Date) => {
      current = new Date(current.toDateString()); // remove time from datetime object
      return current < first || current > last || +current === +otherDate;
    };
    return fn;
  }

  cancelRangePick(data: any) {
    data.openRangePicker = 0;
    if (this.range[0] > this.range[1]) {
      const temp = this.range[0];
      this.range[0] = this.range[1];
      this.range[1] = temp;
    }
    this.datePickers?.forEach((item) => item.close());
  }

  getTimeframe(telemetry: CurrentTelemetry) {
    const display: GraphDisplay | any = this.graphDisplays.find(
      (graphDisplay) =>
        graphDisplay?.currentTelemetry?.measurementTypeID === telemetry?.measurementTypeID &&
        graphDisplay?.currentTelemetry?.sensor?.sensorID === telemetry?.sensor?.sensorID
    );
    return display ? display.timeframe : null;
  }

  resetTimeframeSelect(telemetry: CurrentTelemetry) {
    this.onTelemetryTimeframeSelect(this.lastTimeframeSelectIndex, telemetry);
  }

  private calcSteamLossInfo() {
    // make sure to cutoff at midnight:
    if (!this.range || !this.range[0] || !this.range[1]) {
      return;
    }
    const rangeStart = new Date(this.range[0].toDateString());
    const rangeEnd = new Date(
      new Date(new Date(this.range[1]).setDate(this.range[1].getDate() + 1))
    );
    const amountValue: number = this.SteamTrapLossAmount.map((display: GraphDisplay) =>
      !display.graphData
        ? 0
        : display.graphData
            .map((data: GraphData) =>
              data.telemetry
                .filter((telemetry) => {
                  return (
                    new Date(telemetry.timestamp).getTime() > rangeStart.getTime() &&
                    new Date(telemetry.timestamp).getTime() < rangeEnd.getTime()
                  );
                })
                .map((telemetry) => telemetry.value)
                .reduce((a, b) => a + b, 0)
            )
            .reduce((a, b) => a + b, 0)
    ).reduce((a, b) => a + b, 0);

    this.steamTrapLossAmountSum =
      amountValue > 1000 ? (amountValue / 1000).toFixed(1) + ' K' : amountValue.toFixed(2);

    const amountMass: number = this.SteamTrapLossMass.map((display: GraphDisplay) =>
      !display.graphData
        ? 0
        : display.graphData
            .map((data: GraphData) =>
              data.telemetry
                .filter(
                  (telemetry) =>
                    new Date(telemetry.timestamp).getTime() > rangeStart.getTime() &&
                    new Date(telemetry.timestamp).getTime() < rangeEnd.getTime()
                )
                .map((telemetry) => telemetry.value)
                .reduce((a, b) => a + b, 0)
            )
            .reduce((a, b) => a + b, 0)
    ).reduce((a, b) => a + b, 0);

    this.steamTrapLossMassSum = amountMass.toFixed(2);
    this.steamTrapLossCo2Sum = (amountMass * CO2_CONVERSION_FACTOR).toFixed(2);
  }

  onTabChanged(tab: any) {
    switch (tab) {
      case 0:
        this.displayViz = this.DISPLAY_STEAM_TRAP_LOSS_AMOUNT;
        this.displaySteamTrapLossAmount = true;
        this.calcSteamLossAmountPrediction();
        break;
      case 1:
        this.displayViz = this.DISPLAY_STEAM_TRAP_LOSS_MASS;
        this.displaySteamTrapLossAmount = false;
        this.calcSteamLossMassPrediction();
        break;
      case 2:
        this.displayViz = this.DISPLAY_STEAM_TRAP_LOSS_CO2;
        this.displaySteamTrapLossAmount = false;
        this.calcSteamLossMassPrediction();
        break;
    }
  }

  calcSteamLossAmountPrediction() {
    this.steamTrapLossAmount1Week = !this.SteamTrapLossAmountWeek
      ? 0
      : this.displayValue(this.SteamTrapLossAmountWeek.value['val']);
    this.steamTrapLossAmount1Month = !this.SteamTrapLossAmountMonth
      ? 0
      : this.displayValue(this.SteamTrapLossAmountMonth.value['val']);
    this.steamTrapLossAmount3Months = !this.SteamTrapLossAmount3Month
      ? 0
      : this.displayValue(this.SteamTrapLossAmount3Month.value['val']);
  }

  calcSteamLossMassPrediction() {
    this.steamTrapLossMass1Week = !this.SteamTrapLossMassWeek
      ? 0
      : this.displayValue(this.SteamTrapLossMassWeek.value['val']);
    this.steamTrapLossMass1Month = !this.SteamTrapLossMassMonth
      ? 0
      : this.displayValue(this.SteamTrapLossMassMonth.value['val']);
    this.steamTrapLossMass3Months = !this.SteamTrapLossMass3Month
      ? 0
      : this.displayValue(this.SteamTrapLossMass3Month.value['val']);
  }

  setSteamLossCurrencyUnitGraph() {
    this.SteamTrapLossAmount.map((display: GraphDisplay) =>
      !display.graphData
        ? 0
        : display.graphData.map(
            (data: GraphData) => (data.metadata.unit = this.steamLossCurrencyUnit)
          )
    );
  }

  setSteamLossMassUnitString(): void {
    if (
      !this.SteamTrapLossMass ||
      !this.SteamTrapLossMass[0] ||
      !this.SteamTrapLossMass[0].graphData
    ) {
      this.steamLossMassUnit = 'Kg';
    }
    const SteamTrapLossMassUnit = this.SteamTrapLossMass[0].graphData[0].metadata.unit;
    this.steamLossMassUnit = SteamTrapLossMassUnit !== '' ? SteamTrapLossMassUnit : 'Kg';
  }

  setSteamLossCo2UnitString() {
    if (
      !this.SteamTrapLossMass ||
      !this.SteamTrapLossMass[0] ||
      !this.SteamTrapLossMass[0].graphData
    )
      return '';
    const SteamTrapLossCo2Unit = this.SteamTrapLossMass[0].graphData[0].metadata.unit;
    this.steamLossCo2Unit = SteamTrapLossCo2Unit !== '' ? SteamTrapLossCo2Unit : 'Kg';
    return '';
  }

  showPrediction() {
    return (
      this.displayViz !== this.DISPLAY_STEAM_TRAP_LOSS_CO2 &&
      (this.SteamTrapLossAmount[0].currentTelemetry.critical ||
        this.SteamTrapLossAmount[0].currentTelemetry.warning ||
        this.SteamTrapLossAmount[0].currentTelemetry.inactive ||
        this.SteamTrapLossMass[0].currentTelemetry.critical ||
        this.SteamTrapLossMass[0].currentTelemetry.warning ||
        this.SteamTrapLossMass[0].currentTelemetry.inactive)
    );
  }

  displayValue = (value: any) => {
    if (value) return value > 1000 ? (value / 1000).toFixed(1) + ' K' : value.toFixed(2);
  };

  public formatValueAndUnit(value: any, unit: string): string {
    if (value > 1000 && unit.toLowerCase() === 'kg') {
      return (value / 1000).toFixed(1) + ' t';
    }

    if (value > 2000 && unit.toLowerCase() === 'lb') {
      return (value / 2000).toFixed(1) + ' t';
    }

    return value + ' ' + unit;
  }
}
